'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactIntl = require('react-intl');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _MainContent = require('./components/MainContent');

var _MainContent2 = _interopRequireDefault(_MainContent);

require('./style.css');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var StandardWorkflowIcon = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEYAAABGCAMAAABG8BK2AAAAUVBMVEVHcEz///////////////////////////////////////////////////////////////////////////////////////////////////////9jlXTzAAAAGnRSTlMAtO0g/MIKBPba5TwXZaXOfY1RbxAqRzNcmdMib0kAAAQeSURBVFjD3Vfr0pwgDFUEuSgIqKh5/wdtUHfFy27160xn2vxT8BiSk5OQZf+91Q/3l/ziZZGDGe5j8GESzQXOIIHKtrzrSSsBRHcBrykAbfrj/kprHY7761wAkPbyD31ckwkO7zXDVxDh2z5xdFDoCqs+xdgqoOH92LUNBUpkIwkiSVu8V0YByn7OSNlPrt5iLoDmY18URR8Mwd+/cbrJVPxeEDFzNPE7gqrhMYk6A2LxrLDtOOC/tYLmKQ43VKzZbzGccioy7gU13TMYL8CUL4pgYEBhYGyagFtHykEmB+AjE6TKeA6MP4GpFDi+5xRgooKg1RMYjEdxSJwQY1YzmH4TU16W/O2AAXZGNpxPIHnywbHGO+1m8+szA3cKl5BlZqla6MmDnT/Y1/JIltIhK4cl6JO/knSZFmqpOTzebMLv8qvEbKr7DGOaMoHJlw/ILuQ8tNF0/z6UPZMAPW1fh8p6PX8QvhLAQH6ZB7eF+F7C6ZUOYkTMI/oRaC9fP6uGOoemOJ8J35aPikoLak9RcJT6hz0oBzLucUr9XCiyvgG1p2irQFaP5Q9xhE1wWgLqJkoZ5BbZiLNxOWCTeS8VUo2fY91P2JW2IBYNyFefKBgknRAbjPjYqUeJbSlP8jyQd01g7Y6J+MTCvO7UpYsVO6VLpQH5XiS7vFn0m15JWCWxoR04agGqIVp1lD0eGLp+kf56StvrSkIKSikplRSn4ihsY67KlJ/HHr0MArO198ak65IA7aPpKx27X1l0bRB180cwYoNpfw7jCTgdzRLwP4dB2VmNPhSaQ3mYZjFTZX/HBmtmc37xmxdDFULVfztFWRTlcR6m6/lFlM16NEwSbHyN0Z+AOm0YM37HvmYjKnHWqI24orkOSGjmPaRNcDp89rH6wgsvjrAMh1h0UukT37uQz3twOZXUGoVjcX5JLmE2FDzjdXBxhnb9DqjzcYCjjQ0eJcdew1CDM2e9DckITCUzJs9z46JqVjmZYxipPULaQVMY4Y9KllQ4NHo+jppmleGoRYkEFV9gcNx/p3GNm3QDX5qWAjHehMHLR7VYQKnAwNk1VHUMUSrb32HSukC/huQGs7vr3IfhBMjrqIhCpp0Q34UpW7pOp9V87Tq0uy8wPVL+bTHW43wJjAfKj5epLzBslyTsk7iviI1VtSdyf4HZsUZIFy8xCE3Zxdy4Y3HunN5ac/fKdrQelYFbrCThrm6Hx5pClydfdxctiOOIgfzzl92po1jhAc2nipHbcTioTRkJSEz/IZN4WoIdVqG/ymrtmoX+RDKXXr+LWJVKfxza+i2Qy3Wjbtnm1bh+5+WRt6dRYqVHvmlU7R2TC7xgdvQtjg+ojd/nR97V0fax6AZvc5JknPkfdipe1mFSa/p0+Ufth1fx/uW77J+xXxbjVdnyuXfQAAAAAElFTkSuQmCC';

var SideMenu = function (_Component) {
  _inherits(SideMenu, _Component);

  function SideMenu(props) {
    _classCallCheck(this, SideMenu);

    var _this = _possibleConstructorReturn(this, (SideMenu.__proto__ || Object.getPrototypeOf(SideMenu)).call(this, props));

    var isSwitchOn = JSON.parse(window.localStorage.getItem('isSwitchOn'));
    _this.state = {
      isSwitchOn: isSwitchOn || false
    };
    _this.handleToggle = _this.handleToggle.bind(_this);
    return _this;
  }

  _createClass(SideMenu, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (prevState.isSwitchOn !== this.state.isSwitchOn) {
        window.localStorage.setItem('isSwitchOn', this.state.isSwitchOn);
      }
    }
  }, {
    key: 'handleToggle',
    value: function handleToggle() {
      this.setState(function (prevState) {
        return {
          isSwitchOn: !prevState.isSwitchOn
        };
      });
    }
  }, {
    key: 'renderToggleIcon',
    value: function renderToggleIcon() {
      var isSwitchOn = this.state.isSwitchOn;

      return _react2.default.createElement('i', { className: (0, _classnames2.default)('fa fa-angle-left sidebar-menu-arrow-icon', { 'sidebar-menu-icon--active': isSwitchOn }) });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var intl = this.props.intl;
      var isSwitchOn = this.state.isSwitchOn;

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { className: 'sidebar-menu-container' },
          _react2.default.createElement(
            'div',
            {
              className: 'sidebar-menu-close',
              onClick: function onClick() {
                _this2.props.onClose();
              }
            },
            _react2.default.createElement(
              'div',
              { className: 'sidebar-menu-close-button' },
              _react2.default.createElement(
                'div',
                { className: 'sidebar-menu-close-icon' },
                _react2.default.createElement('div', { className: 'sidebar-menu-close-bar' }),
                _react2.default.createElement('div', { className: 'sidebar-menu-close-bar-second' })
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'sidebar-menu-block' },
            _react2.default.createElement(
              'div',
              { className: 'sidebar-menu-toggle', onClick: this.handleToggle },
              _react2.default.createElement('img', { className: 'sidebar-menu-toggle__icon', src: StandardWorkflowIcon, alt: '\u5E38\u7528\u6D41\u7A0B' }),
              this.renderToggleIcon()
            ),
            _react2.default.createElement(_MainContent2.default, { isSwitchOn: isSwitchOn, intl: intl })
          )
        )
      );
    }
  }]);

  return SideMenu;
}(_react.Component);

SideMenu.propTypes = {
  onClose: _propTypes2.default.func,
  intl: _propTypes2.default.func
};

exports.default = (0, _reactIntl.injectIntl)(SideMenu);


/*****************
 ** WEBPACK FOOTER
 ** ./~/@mayo/xe-ui-kit/lib/components/SideMenu/index.js
 ** module id = 2021
 ** module chunks = 73
 **/